import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';

import './style.scss';
import './mobile.scss';

const RubricAppearanceBanner = (props) => {
  const
    {rubric} = props,
    {is_mobile} = props.applicationState,
    banner = rubric.rubric_appearance?.banner;

  if (!banner) {
    return null;
  }

  return (
    <section className='page-content-section'>
      <div className="rubric-appearance-banner">
        {
          banner.is_video ?
            <video className='rubric-appearance-banner__bg' autoPlay loop muted>
              <source src={banner.attachment} />
            </video>
            :
            <div className="rubric-appearance-banner__bg" style={{backgroundImage: `url(${banner.banner_bg.image})`}}/>
        }
        <div className="rubric-appearance-banner__text">
          {banner.text}
        </div>
      </div>
    </section>
  );
}

const
  mapStateToProps = ({applicationState, railsContext}) => {
    return {
      applicationState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    null
  );

export default compose(withConnect)(RubricAppearanceBanner);

